// import router from "../../router";
// import request from "../../utils/request";

const state = {
    step: {
        Category: null
    }
};

const mutations = {
    setCategory() {

    }
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};